import { useEffect, useState } from 'react';

export const useOnlineStatusDetector = () => {
  const [isOnline, setIsOnline] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const handleConnection = async () => {
    if (!window.navigator.onLine) {
      setIsOnline(false);
      setIsLoaded(true);
      return false;
    }

    const timeoutPromise = new Promise((_, reject) =>
      // eslint-disable-next-line no-promise-executor-return
      setTimeout(() => reject(new Error('Timeout')), 3000)
    );

    try {
      const response = await Promise.race([
        fetch('https://httpbin.org/status/204', {
          cache: 'no-store',
          method: 'HEAD',
        }),
        timeoutPromise, // If there is no response in 3 sec => set offline
      ]);
      setIsOnline(!!response.ok && response.status === 204);
      setIsLoaded(true);
      return response.ok && response.status === 204;
    } catch {
      setIsLoaded(true);
      setIsOnline(false);
    }

    return isOnline;
  };

  useEffect(() => {
    handleConnection();
    window.addEventListener('online', handleConnection);
    window.addEventListener('offline', handleConnection);
  }, []);

  return { isLoaded, isOnline };
};
